import { useState, useEffect, createContext, useContext } from 'react';
import { verifyToken, logout as apiLogout, getToken } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  async function checkAuth() {
    const token = getToken();
    
    if (!token) {
      setLoading(false);
      setIsAuthenticated(false);
      return;
    }

    try {
      const response = await verifyToken();
      if (response.valid) {
        setAdmin(response.admin);
        setIsAuthenticated(true);
      } else {
        apiLogout();
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      apiLogout();
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }

  function login(adminData) {
    setAdmin(adminData);
    setIsAuthenticated(true);
  }

  function logout() {
    apiLogout();
    setAdmin(null);
    setIsAuthenticated(false);
  }

  const value = {
    admin,
    loading,
    isAuthenticated,
    login,
    logout,
    checkAuth,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export default useAuth;

